import { Alert, Typography } from "@mui/material";
import { useGetList, useGetMany, useGetOne } from "react-admin";
import { CreateExamForm } from "../AddAppointmentDialog/CreateExamForm";
import { PracticalExam } from "../../model/autovioCalendarEvents";
import { Instructor } from "../../providers/instructorsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { Student } from "../../providers/studentsProvider";
import { Vehicle } from "../../providers/vehiclesProvider";
import { useGetDrivingLessonStartingPoint } from "../../hooks/useGetCalendarEventStartingPoint";
import { vehiclesForLicenseClass } from "./vehiclesForLicenseClass";

const _notBilledWarning =
  "Achtung: Hier dokumentierte Termine werden nicht abgerechnet. Für eine Abrechnung bitte den Termin regulär planen.";

export function DocumentHistoricalPracticalExamForm({
  student,
  onSuccess,
}: {
  student: Student;
  onSuccess: () => void;
}) {
  const { data: practicalExams = [], isLoading: isLoadingPracticalExams } = useGetList<PracticalExam>(
    "studentDrivingLessons",
    {
      filter: {
        studentUid: student.id,
        drivingSchoolId: student.drivingSchoolId,
        drivingLessonType: "praktischePruefung",
      },
      pagination: { page: 1, perPage: 1 },
      sort: { field: "start", order: "DESC" },
    },
  );
  const lastPracticalExam = practicalExams[0];
  const { data: instructor } = useGetOne<Instructor>(
    "instructors",
    { id: lastPracticalExam?.instructorId || "" },
    { enabled: !!lastPracticalExam?.instructorId },
  );
  const bookedTraining = student.bookedTrainings?.find((bt) => bt.id === lastPracticalExam?.student.bookedTrainingId);
  const { data: vehiclesData = [] } = useGetMany<Vehicle>(
    "vehicles",
    { ids: lastPracticalExam?.resources ?? [] },
    { enabled: !!lastPracticalExam?.resources?.length },
  );
  const { startingPoint, isLoading: isLoadingStartingPoint } = useGetDrivingLessonStartingPoint(student);

  if (isLoadingPracticalExams || isLoadingStartingPoint) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Alert severity="warning" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="body2">{_notBilledWarning}</Typography>
      </Alert>
      <CreateExamForm
        isHistoricalLesson
        initialExamType="praktischePruefung"
        student={student}
        instructor={instructor}
        drivingLicenseClass={bookedTraining?.drivingLicenseClass}
        vehicles={vehiclesForLicenseClass(vehiclesData, bookedTraining)}
        startingPoint={startingPoint}
        initialDurationInMinutes={
          lastPracticalExam ? Math.round(lastPracticalExam.end.diff(lastPracticalExam.start).as("minutes")) : undefined
        }
        onSuccess={onSuccess}
      />
    </>
  );
}
